import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification is-danger"
}
const _hoisted_2 = { class: "fieldset" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Акция", -1)
const _hoisted_5 = { class: "control" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-- Не выбрано --", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "Доп.начисление за агента" }, "Доп.начисление за агента", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Сумма начисления", -1)
const _hoisted_11 = { class: "control" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    (_ctx.errorMessages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages, (msg, idx) => {
              return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(msg), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.promotion) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)))
          }, _hoisted_8, 544), [
            [_vModelSelect, _ctx.promotion]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "number",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localAmount) = $event)),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args))),
            placeholder: "Введите сумму"
          }, null, 544), [
            [
              _vModelText,
              _ctx.localAmount,
              void 0,
              { number: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.isFormLoading }]),
          type: "submit",
          disabled: !_ctx.isFormValid || _ctx.isFormLoading
        }, "Сохранить", 10, _hoisted_12)
      ])
    ])
  ], 32))
}